import { useMemo } from 'react';

import dayjs from 'dayjs';

export const useIsPastEvent = (event: { startDate: string; startTime?: string }) => {
  const isPastEvent = useMemo(
    () => event && dayjs().isAfter(`${event?.startDate} ${event?.startTime ?? '00:00'}`),
    [event?.startDate, event?.startTime],
  );

  return { isPastEvent };
};
